import React from 'react';

interface Props {
    children?: React.ReactNode;
    className?: string;
    htmlFor?: string;
}

export default function FormLabel({ children, className = '', htmlFor }: Props) {
    return (
        <label htmlFor={htmlFor} className={`form-label ${className}`.trim()}>
            {children}
        </label>
    );
}
